<template>
  <div class="patientInfoBar" :class="userStore.borderClass">
    <!-- :style="{ color: record.gender === 'F' ? 'green' : 'red', background: record.gender === 'F' ? 'darkblue' : 'darkgoldenrod' }" -->
    <!-- <span style="color: cyan">UPatient Store : patientIDStartList {{ usersPatStore.patientIDStartList }} <br /></span> -->

    <b-container fluid>
      <b-row>
        <b-col cols="2" style="background: transparent; padding: 3px">
          <b-row>
            <b-col cols="2">
              <b-button
                v-if="patientStore.currentPatient && patientStore.currentPatient.personID"
                :class="modalTheme"
                @click="handleClick"
                type="button"
                v-b-tooltip.hover.right
                :title="canAddCurrentPatient ? 'Add patient to your list' : 'Remove patient from your list'"
                variant="primary-green"
                size="sm"
                style="margin-right: 3px"
              >
                <font-awesome-icon :icon="canAddCurrentPatient ? ['fas', 'user-plus'] : ['fas', 'user-minus']" size="lg" />
              </b-button>
            </b-col>
            <b-col cols="10" style="background: transparent; padding: 0%" v-b-toggle.collapseDashboard>
              <span class="patientName" v-b-tooltip.hover.right="{ title: 'Click for Dashboard', customClass: 'my-popover-class' }">
                {{ patientStore.currentPatient.lastName }}, {{ patientStore.currentPatient.firstName }}
              </span>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="4" style="background: transparent; padding: 6px">
          <b-row no-gutters style="font-size: smallest">
            <b-col>
              <span>DOB:</span>
              <span>{{ patientStore.currentPatient.dateOfBirth }}</span>
            </b-col>
            <b-col style="font-size: smaller">
              <span>Patient ID:</span>
              <span style="margin-right: 11px">{{ patientStore.currentPatient.patientID }} </span>
              <span>Member Id:</span>
              <span>{{ patientStore.currentPatient.memberID }}</span>
            </b-col>
          </b-row>
          <b-row no-gutters style="font-size: x-small">
            <b-col>
              <span>Insurance:</span>
              <span>{{ patientStore.currentPatient.insuranceCarrier }}</span>
            </b-col>
            <b-col> </b-col>
          </b-row>
          <b-row no-gutters style="font-size: smaller">
            <b-col>
              <span>LOV:</span>
              <span>{{ patientStore.currentPatient.providerName }} {{ patientStore.currentPatient.serviceDate }}</span>
            </b-col>
            <b-col>
              <span>NOV:</span>
              <span>
                {{ patientStore.currentPatient.nextAppointmentWith }}
                <!-- {{ patientStore.currentPatient.nextAppointment }} -->
              </span>
              <br />
              {{ patientStore.currentPatient.nextAppointmentReason }}
            </b-col>
          </b-row>
        </b-col>

        <b-col style="background: transparent; padding: 6px" class="d-flex justify-content-center">
          <b-row class>
            <b-col cols="*">
              <!-- <b-badge pill variant="inspinia"> Problems: xxxxxxx </b-badge> -->
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[1]" v-show="taskbuilderStore.taskRecords[1].length > 0" pill variant="inspinia">
                Problems: {{ taskbuilderStore.taskRecords[1].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[10]" v-show="taskbuilderStore.taskRecords[10].length > 0" pill variant="inspinia">
                Meds: {{ taskbuilderStore.taskRecords[10].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[11]" v-show="taskbuilderStore.taskRecords[11].length > 0" pill variant="inspinia">
                Labs: {{ taskbuilderStore.taskRecords[11].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[12]" v-show="taskbuilderStore.taskRecords[12].length > 0" pill variant="inspinia"
                >Vitals: {{ taskbuilderStore.taskRecords[12].length }}</b-badge
              >
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[13]" v-show="taskbuilderStore.taskRecords[13].length > 0" pill href="#" variant="inspinia">
                Immunz: {{ taskbuilderStore.taskRecords[13].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[14]" v-show="taskbuilderStore.taskRecords[14].length > 0" pill href="#" variant="inspinia">
                Reminders {{ taskbuilderStore.taskRecords[14].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[20]" v-show="taskbuilderStore.taskRecords[20].length > 0" pill href="#" variant="inspinia">
                In-Patient Visits:
                {{ taskbuilderStore.taskRecords[20].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[21]" v-show="taskbuilderStore.taskRecords[21].length > 0" pill href="#" variant="inspinia">
                Procedures: {{ taskbuilderStore.taskRecords[21].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[23]" v-show="taskbuilderStore.taskRecords[23].length > 0" pill href="#" variant="inspinia">
                Allergies: {{ taskbuilderStore.taskRecords[23].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[50]" v-show="taskbuilderStore.taskRecords[50].length > 0" pill href="#" variant="inspinia">
                Communications:
                {{ taskbuilderStore.taskRecords[50].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[60]" v-show="taskbuilderStore.taskRecords[60].length > 0" pill href="#" variant="inspinia"
                >Measures: {{ taskbuilderStore.taskRecords[60].length }}</b-badge
              >
            </b-col>
            <!-- <b-col cols="*" v-if="checkForTaskRoute()">
              <b-nav pills justified>
                <b-nav-item to="/Dashboard/Work/MyWork">Patient Tasks</b-nav-item>
              </b-nav>
            </b-col> -->
          </b-row>
        </b-col>
        <b-col style="background: transparent; padding: 0px" sm="auto" class="d-flex justify-content-end">
          <CreateNewTaskButtonSidebar class="mx-auto mb-2" :records="taskbuilderStore.getAllTaskRecords" :context="context" />
        </b-col>
      </b-row>

      <b-collapse id="collapseDashboard">
        <!-- <div style="background: darkblue">sxxxxxxxxxx</div> -->
        <b-card style="height: 100%; width: 100%; overflow-y: auto">
          <InfoBarStepperORG />
          <!-- <InfoBarStepper /> -->
          <!-- <h6>Dashboard Status</h6> -->
        </b-card>
      </b-collapse>
    </b-container>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";

import CreateNewTaskButtonSidebar from "@/modules/Messaging/CreateNewTaskButtonSidebar.vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
import InfoBarStepper from "@/modules/Patient/Steppers/InfoBarStepperForm.vue";
import InfoBarStepperORG from "@/modules/Patient/Steppers/InfoBarStepperORG.vue";
const userStore = useStoreUser();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();
import { useStoreTaskBuilder } from "@/stores/taskBuilderStore";
const taskbuilderStore = useStoreTaskBuilder();
// * STOREs
import { useUsersPatientsStore } from "@/stores/usersPatientStore";
const usersPatStore = useUsersPatientsStore();

import { toast } from "vue3-toastify";

const numbers = ref([1, 2, 3, 4, 5]);

const removeNumberWithSplice = (indexToRemove) => {
  numbers.value.splice(indexToRemove, 1);
};

const addNumber = () => {
  const newNumber = numbers.value.length > 0 ? Math.max(...numbers.value) + 1 : 1;
  numbers.value.push(newNumber);
};

const context = {
  location: "Context.Demographics",
  title: "Create Task/Message",
};

const modalTheme = computed(() => userStore.bModalTheme);

const isActive = ref(false); // Reactive boolean

const activateState = () => {
  // console.log("State is now active!");

  const id = patientStore.currentPatient.personID;
  // console.log(" personID ", id);

  // find patient by id
  const patient = usersPatStore.masterPatientList.find((patient) => patient.personID === id);

  // console.log(" Pid: " + patient.lastName + " : " + patient.personID + " -  " + patient.isScheduled);

  // // check isScheduled
  const isScheduled = usersPatStore.scheduledPatients.includes(patient);
  // console.log(" isScheduled: " + isScheduled);

  if (id && !usersPatStore.patientIDStartList.includes(id)) {
    // console.log(" Patient Added to userPList : ", id);
    usersPatStore.patientIDStartList.push(id);

    // find patient from masterPatientList by personID
    const patient = usersPatStore.masterPatientList.find((patient) => patient.personID === id);
    // console.log(" Found patient in masterPatientList: ", patient.lastName + " : " + patient.isScheduled);
    usersPatStore.assignMasterPatient(patient.personID, patient.isScheduled);

    // Show success toast
    // toast.success(`Patient ${patientStore.currentPatient.firstName} ${patientStore.currentPatient.lastName} added to your list`);
  } else {
    // console.log("Patient already in list or invalid ID");
    toast.info("Patient is already in your list");
  }
};

const deactivateState = () => {
  // console.log("State is now inactive!");

  const id = patientStore.currentPatient.personID;
  // console.log("Removing patient ID:", id);

  if (id && usersPatStore.patientIDStartList.includes(id)) {
    // Remove from patientIDStartList
    usersPatStore.patientIDStartList = usersPatStore.patientIDStartList.filter((patientId) => patientId !== id);

    // Unassign from master patient list
    usersPatStore.unassignMasterPatient(id);

    // console.log("Patient removed from list:", id);
    toast.success(`Patient ${patientStore.currentPatient.firstName} ${patientStore.currentPatient.lastName} removed from your list`);
  } else {
    // console.log("Patient not found in list or invalid ID");
    toast.warning("Patient not found in your list");
  }
};

const removeNumberWithFilter = (numToRemove) => {
  usersPatStore.patientIDStartList = usersPatStore.patientIDStartList.filter((num) => num !== numToRemove);
  // toast.error("Patient Removed from list !  User's Patient Store");
};

const handleClick = () => {
  if (canAddCurrentPatient.value) {
    activateState();
  } else {
    deactivateState();
  }

  // console.log("Can add current patient:", canAddCurrentPatient.value);
};

const canAddCurrentPatient = computed(() => {
  // console.log("      canAddCurrentPatient                      personID");
  // console.log(patientStore.currentPatient.personID);
  // console.log(patientStore.currentPatient && !usersPatStore.patientIDStartList.includes(patientStore.currentPatient.personID));

  // console.log(usersPatStore.patientIDStartList);
  return patientStore.currentPatient && !usersPatStore.patientIDStartList.includes(patientStore.currentPatient.personID);
});

function addCurrentPatientToStartList() {
  // switch to filter masterlist

  const id = patientStore.currentPatient.personID;
  if (id && !usersPatStore.masterPatientList.includes(id)) {
    usersPatStore.patientIDStartList.push(id);
    // console.log(" Patient Added to userPList : ", id);
    toast.success(" Patient Added to userPList : ", id);

    //  loadPatients();
  }
}
function removeCurrentPatientFromSchedule() {
  // console.log(">>>>>>>  removeCurrentPatientFromSchedule");

  const id = patientStore.currentPatient.personID;

  // Find the index of the patient in scheduledPatients array by personID
  const patientIndex = usersPatStore.scheduledPatients.findIndex((patient) => patient.personID === id);

  if (patientIndex !== -1) {
    // Remove the patient using splice with the correct index
    const removedPatient = usersPatStore.scheduledPatients.splice(patientIndex, 1)[0];
    // console.log(" REMOVED Patient from scheduledPatients : ", id);
    // console.log(" Removed patient details: ", removedPatient);

    // Also update the master patient list to reflect the change
    const masterPatient = usersPatStore.masterPatientList.find((p) => p.personID === id);
    if (masterPatient) {
      masterPatient.isScheduledTEMP = false;
    }

    toast.success(`Patient ${removedPatient.lastName}, ${removedPatient.firstName} removed from scheduled list`);

    //loadPatients();
  } else {
    // console.log("Patient not found in scheduled patients list");
    toast.warning("Patient not found in scheduled list");
  }
}
async function loadPatients() {
  // console.log("LOADing      Patients >...... ");

  // console.log("                     Load patients from userPat Store  patientIDList: ", usersPatStore.patientIDStartList?.length);

  if (usersPatStore.patientIDStartList?.length > 0) {
    usersPatStore.patientIDStartList.forEach((id) => {
      // console.log(" usersPatStore.patientIDStartList ");
      // console.log(" id ", id);
      patientStore.loadPatientsFromIDList(id);
    });
  }

  // // console.log("*CLONE array ST to ST ******************************************************************");
  // usersPatStore.clonePatientArrayToUserPStore()
}

onMounted(() => {
  // console.log("onMounted() :   PATIENT INFO BAR  >>>>>");
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cardDummy {
  color: #325c46;
}

.demographics {
  padding-top: 8px;
  padding-left: 0px;
  color: rgba(0, 0, 0, 0.5);

  div {
    label {
      margin-right: 0.25rem;
    }
  }

  span {
    // ! bad BIND
    color: #123486;
    font-weight: 800;
  }
}

.demographics-buttons {
  // padding-top: 4px;
}

.name {
  font-weight: 600;
  // font-size: 150%;
  // color: $primary-dark-blue;
  padding-left: 0px;
}

.patientName {
  background-color: transparent; // #3f645d;
  // color: #eef8ef;
  margin-left: 9px;
  margin-right: 0px;
  padding: 0px;
  font-size: 1.625rem; //from h4 : 1.1875rem ?
}

.patientDOB {
  font-size: 0.75rem;
  // color: #eef8ef;
  padding-left: 0px;
  padding-right: 10px;
}

.infoSection {
  background-color: #cdfce2; //#77c1b2  2975bd
  color: #123486;
}

.infoSection h6 {
  // color: #b6cc11;
  // background-color: darkgreen;
}

.patientSection {
  background-color: transparent; //#a5dbaa;
  color: #123486;
  margin-left: 0px;
  padding: 0px;
  font-weight: bolder;
  // border-radius: 10px 10px 10px 10px;
  // height: 25px;
}

.btn-primary-green:hover {
  background-color: #17645c;
  color: #93d3cd;
  border: 1px solid #26a69a;
}

.w3-container,
.w3-panel {
  padding: 0.01em 16px;
}

.w3-leftbar {
  // border-left: 4px solid #b0c1b2 !important; //4285f4
}

.w3-pale-blue {
  color: #00fffb !important;
  // background-color:#cdfce2;// #10443f; // #cdfce2 !important;
}

.w3-hover-pale-blue:hover {
  // color: rgb(0, 255, 255) !important;
  background-color: #cdfce2 !important;
}

.w3-border-blue,
.w3-hover-border-blue:hover {
  border-color: #00fffb; //#11cc84 !important;
}

.patientInfoBar {
  // background-color: #ae208d;
  // border: 3px solid #11cc84;
  // padding: 3px;
  // background-color: #0d4e3567;
  // background: linear-gradient(0.3625turn, #23f577, #0a311aa7, #141b19f0, #273062f0, #273062f0);

  //* current
  // height: 38px;
  // border-radius: 8px;
  // color: red; // #42948248;
  // font-size: 14px;
  // margin-left: 0.5rem;
  // margin-right: 0.5rem;
  // margin-bottom: 0.25rem;
}

.bv-example-row {
  // background-color: #252525;
  margin-left: 0px;
}

.nav-link {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
  line-height: 1.25;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #eaf7ebc8;
  // background-color: #43997848;
  border-color: #43997848 #43997848 #43997848;
  // border-radius: 5px;
  font-weight: bold;
}

.nav-link:hover,
.nav-link:focus {
  // text-decoration: underline solid cyan;
  background-color: #43756c; //#0ca2d4be;
  color: cyan;
  font-weight: bolder;
}

.nav-pills .nav-link.active {
  background-color: #018955c4;
  color: #eaf7ebc8;
  font-weight: bold;
}

.nav-pills .nav-link {
  border-radius: 5px;
}

.chart-review-needed-label {
  background: yellow;
  padding: 1em;
  margin-left: 1em;
}

.chartReviewButton {
  animation: needToReview 3s infinite;
}

.chart-review-comment {
  display: flex;
  margin-left: 0.75em;
  align-content: flex-end;

  // padding: 3em 0;
  .label {
    color: rgba(0, 0, 0, 0.5);
    // font-weight: 700;
  }

  .comment {
    margin-left: 0.5em;
    border-radius: 0.25em;
    padding: 0 1em;
    //   background: $primary-light-gray;
    max-width: 30em;
    overflow-x: hidden;

    &:hover {
      cursor: pointer;
    }
  }
}

@keyframes needToReview {
  0% {
    padding: 0.5em;
  }

  50% {
    padding: 1em;
  }

  100% {
    padding: 0.5em;
  }
}

@import url("https://fonts.googleapis.com/css2?family=Baloo+2&display=swap");
$main-green: #79dd09 !default;
$main-green-rgb-015: rgba(121, 221, 9, 0.1) !default;
$main-yellow: #bdbb49 !default;
$main-yellow-rgb-015: rgba(189, 187, 73, 0.1) !default;
$main-red: #bd150b !default;
$main-red-rgb-015: rgba(189, 21, 11, 0.1) !default;
$main-blue: #0076bd !default;
$main-blue-rgb-015: rgba(0, 118, 189, 0.1) !default;

/* This pen */
body {
  font-family: "Baloo 2", cursive;
  font-size: 16px;
  color: #eaf7eb;
  text-rendering: optimizeLegibility;
  font-weight: initial;
}

.dark {
  background: #110f16;
}

.light {
  background: #f3f5f7;
}

a,
a:hover {
  text-decoration: none;
  transition: color 0.3s ease-in-out;
}

#pageHeaderTitle {
  margin: 2rem 0;
  text-transform: uppercase;
  text-align: center;
  font-size: 2.5rem;
}

/* Cards */
.postcard {
  flex-wrap: wrap;
  display: flex;

  box-shadow: 0 4px 21px -12px rgba(0, 0, 0, 0.66);
  border-radius: 5px;
  margin: 0 0 2rem 0;
  overflow: hidden;
  position: relative;
  color: #eaf7eb;

  &.dark {
    background-color: #18151f;
  }

  &.light {
    background-color: #e1e5ea;
  }

  .t-dark {
    color: #18151f;
  }

  a {
    color: inherit;
  }

  h1,
  .h1 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
  }

  .small {
    font-size: 80%;
  }

  .postcard__title {
    font-size: 1.75rem;
  }

  .postcard__img {
    max-height: 180px;
    width: 100%;
    object-fit: cover;
    position: relative;
  }

  .postcard__img_link {
    display: contents;
  }

  .postcard__bar {
    width: 50px;
    height: 10px;
    margin: 10px 0;
    border-radius: 5px;
    background-color: #424242;
    transition: width 0.2s ease;
  }

  .postcard__text {
    padding: 1.5rem;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .postcard__preview-txt {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: justify;
    height: 100%;
  }

  .postcard__tagbox {
    display: flex;
    flex-flow: row wrap;
    font-size: 14px;
    margin: 20px 0 0 0;
    padding: 0;
    justify-content: center;

    .tag__item {
      display: inline-block;
      background: rgba(83, 83, 83, 0.4);
      border-radius: 3px;
      padding: 2.5px 10px;
      margin: 0 5px 5px 0;
      cursor: default;
      user-select: none;
      transition: background-color 0.3s;

      &:hover {
        background: rgba(83, 83, 83, 0.8);
      }
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(-70deg, #424242, transparent 50%);
    opacity: 1;
    border-radius: 5px;
  }

  &:hover .postcard__bar {
    width: 100px;
  }
}

@media screen and (min-width: 769px) {
  .postcard {
    flex-wrap: inherit;

    .postcard__title {
      font-size: 1.5rem;
    }

    .postcard__tagbox {
      justify-content: start;
    }

    .postcard__img {
      max-width: 300px;
      max-height: 100%;
      transition: transform 0.3s ease;
    }

    .postcard__text {
      padding: 3rem;
      width: 100%;
    }

    .media.postcard__text:before {
      content: "";
      position: absolute;
      display: block;
      background: #18151f;
      top: -20%;
      height: 130%;
      width: 55px;
    }

    &:hover .postcard__img {
      transform: scale(1.1);
    }

    &:nth-child(2n + 1) {
      flex-direction: row;
    }

    &:nth-child(2n + 0) {
      flex-direction: row-reverse;
    }

    &:nth-child(2n + 1) .postcard__text::before {
      left: -12px !important;
      transform: rotate(4deg);
    }

    &:nth-child(2n + 0) .postcard__text::before {
      right: -12px !important;
      transform: rotate(-4deg);
    }
  }
}

@media screen and (min-width: 1024px) {
  .postcard__text {
    padding: 2rem 3.5rem;
  }

  .postcard__text:before {
    content: "";
    position: absolute;
    display: block;

    top: -20%;
    height: 130%;
    width: 55px;
  }

  .postcard.dark {
    .postcard__text:before {
      background: #18151f;
    }
  }

  .postcard.light {
    .postcard__text:before {
      background: #e1e5ea;
    }
  }
}

/* COLORS */
.postcard .postcard__tagbox .green.play:hover {
  background: $main-green;
  color: black;
}

.green .postcard__title:hover {
  color: $main-green;
}

.green .postcard__bar {
  background-color: $main-green;
}

.green::before {
  background-image: linear-gradient(-30deg, $main-green-rgb-015, transparent 50%);
}

.green:nth-child(2n)::before {
  background-image: linear-gradient(30deg, $main-green-rgb-015, transparent 50%);
}

.postcard .postcard__tagbox .blue.play:hover {
  background: $main-blue;
  color: black;
}

.blue .postcard__title:hover {
  color: $main-blue;
}

.blue .postcard__bar {
  background-color: $main-blue;
}

.blue::before {
  background-image: linear-gradient(-30deg, $main-blue-rgb-015, transparent 50%);
}

.blue:nth-child(2n)::before {
  background-image: linear-gradient(30deg, $main-blue-rgb-015, transparent 50%);
}

.postcard .postcard__tagbox .red.play:hover {
  background: $main-red;
  color: black;
}

.red .postcard__title:hover {
  color: $main-red;
}

.red .postcard__bar {
  background-color: $main-red;
}

.red::before {
  background-image: linear-gradient(-30deg, $main-red-rgb-015, transparent 50%);
}

.red:nth-child(2n)::before {
  background-image: linear-gradient(30deg, $main-red-rgb-015, transparent 50%);
}

.postcard .postcard__tagbox .yellow.play:hover {
  background: $main-yellow;
  color: black;
}

.yellow .postcard__title:hover {
  color: $main-yellow;
}

.yellow .postcard__bar {
  background-color: $main-yellow;
}

.yellow::before {
  background-image: linear-gradient(-30deg, $main-yellow-rgb-015, transparent 50%);
}

.yellow:nth-child(2n)::before {
  background-image: linear-gradient(30deg, $main-yellow-rgb-015, transparent 50%);
}

@media screen and (min-width: 769px) {
  .green::before {
    background-image: linear-gradient(-80deg, $main-green-rgb-015, transparent 50%);
  }

  .green:nth-child(2n)::before {
    background-image: linear-gradient(80deg, $main-green-rgb-015, transparent 50%);
  }

  .blue::before {
    background-image: linear-gradient(-80deg, $main-blue-rgb-015, transparent 50%);
  }

  .blue:nth-child(2n)::before {
    background-image: linear-gradient(80deg, $main-blue-rgb-015, transparent 50%);
  }

  .red::before {
    background-image: linear-gradient(-80deg, $main-red-rgb-015, transparent 50%);
  }

  .red:nth-child(2n)::before {
    background-image: linear-gradient(80deg, $main-red-rgb-015, transparent 50%);
  }

  .yellow::before {
    background-image: linear-gradient(-80deg, $main-yellow-rgb-015, transparent 50%);
  }

  .yellow:nth-child(2n)::before {
    background-image: linear-gradient(80deg, $main-yellow-rgb-015, transparent 50%);
  }
}

body {
  background-color: #110f16;
}

.title {
  margin-bottom: 50px;
  text-transform: uppercase;
}

.card-block {
  font-size: 1em;
  position: relative;
  margin: 0;
  padding: 1em;
  border: none;
  border-top: 1px solid rgba(34, 36, 38, 0.1);
  box-shadow: none;
}

.card {
  font-size: 1em;
  overflow: hidden;
  padding: 5;
  border: none;
  border-radius: 0.28571429rem;
  box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
  margin-top: 20px;
}

.carousel-indicators li {
  border-radius: 12px;
  width: 12px;
  height: 12px;
  background-color: #404040;
}

.carousel-indicators li {
  border-radius: 12px;
  width: 12px;
  height: 12px;
  background-color: #404040;
}

.carousel-indicators .active {
  background-color: white;
  max-width: 12px;
  margin: 0 3px;
  height: 12px;
}

.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E") !important;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E") !important;
}

.btn {
  margin-top: auto;
}

@import url("https://fonts.googleapis.com/css?family=Abel");

html,
body {
  background: #fceeb5;
  font-family: Abel, Arial, Verdana, sans-serif;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
}

// TODO
.card {
  width: 525px;
  min-width: 150px;
  height: 125px;
  background-color: #10443f;
  // background: linear-gradient(217deg, #26a69a, rgba(255, 0, 0, 0) 70.71%),
  // 	linear-gradient(127deg, #10443f, rgba(0, 255, 0, 0) 70.71%),
  // 	linear-gradient(336deg, #0089ff, rgba(0, 0, 255, 0) 70.71%);
  box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  margin: 0.3rem;
}

.card h1 {
  text-align: center;
}

.card .additional {
  position: absolute;
  width: 150px;
  height: 100%;
  background: linear-gradient(#2d27a8, #b8adac);
  transition: width 0.4s;
  overflow: hidden;
  z-index: 2;
}

.card.green .additional {
  background: linear-gradient(#92bca6, #a2ccb6);
}

.card:hover .additional {
  width: 100%;
  border-radius: 0 5px 5px 0;
}

.card .additional .user-card {
  width: 150px;
  height: 100%;
  position: relative;
  float: left;
}

.card .additional .user-card::after {
  content: "";
  display: block;
  position: absolute;
  top: 10%;
  right: -2px;
  height: 80%;
  border-left: 2px solid rgba(0, 0, 0, 0.025);
}

.card .additional .user-card .level,
.card .additional .user-card .points {
  top: 15%;
  color: #eef8ef;
  text-transform: uppercase;
  font-size: 0.75em;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.15);
  padding: 0.125rem 0.75rem;
  border-radius: 100px;
  white-space: nowrap;
}

.card .additional .user-card .points {
  top: 85%;
}

.card .additional .user-card svg {
  top: 50%;
}

.card .additional .more-info {
  width: 300px;
  float: left;
  position: absolute;
  left: 150px;
  height: 100%;
}

.card .additional .more-info h1 {
  color: #eef8ef;
  margin-bottom: 0;
}

.card.green .additional .more-info h1 {
  color: #224c36;
}

.card .additional .coords {
  margin: 0 1rem;
  color: #eef8ef;
  font-size: 1rem;
}

.card.green .additional .coords {
  color: #325c46;
}

.card .additional .coords span + span {
  float: right;
}

.card .additional .stats {
  font-size: 2rem;
  display: flex;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  top: auto;
  color: #eef8ef;
}

.card.green .additional .stats {
  color: #325c46;
}

.card .additional .stats > div {
  flex: 1;
  text-align: center;
}

.card .additional .stats i {
  display: block;
}

.card .additional .stats div.title {
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
}

.card .additional .stats div.value {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.5rem;
}

.card .additional .stats div.value.infinity {
  font-size: 2.5rem;
}

.card .general {
  width: 300px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  box-sizing: border-box;
  padding: 0.5rem;
  padding-top: 0;
}

.card .general .more {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  font-size: 0.9em;
}

img {
  border-radius: 15%;
  border: 3px solid #49b293;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.badge-inspinia {
  background: #c6d9c8;
  color: #323632;
}
</style>
